export default "__VITE_PUBLIC_ASSET__5448f609__"